import {
    ClipboardDocumentListIcon,
    FolderIcon,
    PlayIcon,
    UserGroupIcon,
} from "@heroicons/react/24/outline";

/** Shared icon sizing/color for all resource not-found states */
export const NOT_FOUND_ICON_PROPS = {
    width: 28,
    height: 28,
    color: "#2563eb",
};

export const NOT_FOUND_ICON_BOX_SX = {
    bgcolor: "#eff6ff",
    borderRadius: 2,
    p: 1.2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

/**
 * Icons aligned with sidebar / in-app navigation (Sidebar.js).
 * Use these for every ResourceNotFound instance — do not pick ad-hoc icons.
 */
export const NOT_FOUND_RESOURCE_ICONS = {
    project: FolderIcon,           // Sidebar: "All Projects"
    testGroup: UserGroupIcon,      // Sidebar: "Test Groups"
    testCase: ClipboardDocumentListIcon, // Sidebar: "Test Cases"
    module: FolderIcon,            // Module tree folders
    launch: PlayIcon,              // TestGroupDetail launches card / create launch
};
